import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FacturasComponent } from './views/facturas/facturas.component';
import { HomeComponent } from './views/home/home.component';
import { AuthGuard } from 'src/app/shared-module/seguridad/services/auth.guard';
import { ExportarComponent } from './views/exportar/exportar.component';
import { RetencionesComponent } from './views/retenciones/retenciones.component';


const sustentosRoutes: Routes = [
  { path: 'sustentos/home', component: HomeComponent},// canActivate: [AuthGuard]},
  { path: 'sustentos/facturas', component: FacturasComponent},// canActivate: [AuthGuard]},
  { path: 'sustentos/exportar', component: ExportarComponent},// canActivate: [AuthGuard]},
  { path: 'sustentos/retenciones', component: RetencionesComponent}, //canActivate: [AuthGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(sustentosRoutes)],
  exports: [RouterModule]
})
export class SustentosRoutingModule {}
